"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var index_1 = require("../index");
exports.default = React.memo(function (_a) {
    var group = _a.group, onQuickFilter = _a.onQuickFilter, enableQuickFilter = _a.enableQuickFilter;
    var value = group.link
        ? React.createElement(react_router_dom_1.Link, { to: group.link }, group.value)
        : group.value;
    return (enableQuickFilter && onQuickFilter)
        ? React.createElement(index_1.QuickReportAction, { iconName: "icon-filter", tooltipTitle: "Add Filter", item: group, onClick: onQuickFilter }, value)
        : value;
});
